import { memo } from 'react';
import { Link } from 'react-router-dom';

interface PrivacyConsentProps {
  checked: boolean;
  error?: string;
  onChange: (checked: boolean) => void;
}

const PrivacyConsent = memo(({ checked, error, onChange }: PrivacyConsentProps) => (
  <div className="space-y-2">
    <p className="text-xs text-muted-foreground leading-relaxed">
      <strong>Responsable:</strong> Marina González Hurtado. <strong>Finalidad:</strong> responder a tu
      consulta. <strong>Derechos:</strong> acceso, rectificación, supresión y demás derechos indicados en la{' '}
      <Link to="/politica-privacidad" className="text-primary hover:underline">política de privacidad</Link>.
    </p>
    <label htmlFor="privacy" className="flex items-start gap-2 text-sm text-foreground cursor-pointer">
      <input
        id="privacy"
        name="privacy"
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        aria-invalid={!!error}
        aria-describedby={error ? 'privacy-error' : undefined}
        className="mt-0.5 h-4 w-4 shrink-0 accent-primary"
      />
      <span>He leído y acepto la política de privacidad *</span>
    </label>
    {error && (
      <p id="privacy-error" role="alert" className="text-xs text-destructive">{error}</p>
    )}
  </div>
));

PrivacyConsent.displayName = 'PrivacyConsent';

export default PrivacyConsent;
